export default __webpack_public_path__ + "static/media/256.8eeab850.png";